/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DictBase
 */
export interface DictBase {
    /**
     * 
     * @type {string}
     * @memberof DictBase
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof DictBase
     */
    name: string;
}

export function DictBaseFromJSON(json: any): DictBase {
    return DictBaseFromJSONTyped(json, false);
}

export function DictBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DictBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
    };
}

export function DictBaseToJSON(value?: DictBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}


